import { createGlobalStyle } from 'styled-components';

import { primitive } from '../../designTokens/primitives';
import { mediaQuery } from '../mediaQueries';

export const GlobalStyles = createGlobalStyle`
  html {
    --font-hero: ${primitive.th.$hero};
    --font-headerOne: ${primitive.th.$headerOne};
    --font-headerTwo: ${primitive.th.$headerTwo};
    --font-headerThree: ${primitive.th.$headerThree};
    --font-copyOne: ${primitive.th.$copyOne};
    --font-copyTwo: ${primitive.th.$copyTwo};

    @media ${mediaQuery.desktopSmall} {
      --font-headerOne: ${primitive.th.$headerOneDesktop};
      --font-headerTwo: ${primitive.th.$headerTwoDesktop};
      --font-headerThree: ${primitive.th.$headerThreeDesktop};
      --font-copyOne: ${primitive.th.$copyOneDesktop};
      --font-copyTwo: ${primitive.th.$copyTwoDesktop};
    }

    @media ${mediaQuery.desktopLarge} {
      --font-hero: ${primitive.th.$heroDesktop};
    }
  }
`;
